import Typography from "@mui/material/Typography";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import {MusicalInstrumentSelectorMultiple} from "@/components/MusicalInstrumentSelectorMultiple";
import InputLabelStyled from "@/components/InputLabelStyled";
import {Box} from "@mui/system";
import CheckboxStyled from "@/components/CheckboxStyled";

const NetworkLocationFormMusikschulen = ({onChange}) => {
    const handleInputChanged = (event, value) => {
        if (onChange && typeof onChange === "function") {
            onChange(event, value);
        }
    }

    const handleCheckboxChanged = (event) => {
        event.target.value = event.target.checked;

        if (onChange && typeof onChange === "function") {
            onChange(event);
        }
    };

    return (
        <>
            <Typography variant="h4" component="p" color="common.black" sx={{ mt: 4,}}>
                Orts-spezifische Angaben (Musikschulen)
            </Typography>
            <Box className="textarea" sx={{ mb: 1, }}>
                <label>Beschreibung</label>
                <TextareaAutosize
                    aria-label="textarea"
                    placeholder="inhaltlicher Schwerpunkt"
                    name="focus"
                    minRows={4}
                    style={{width: "100%"}}
                    onChange={handleInputChanged}
                />
            </Box>
            <MusicalInstrumentSelectorMultiple
                label="angebotene Instrumente"
                hint="Wähle bis zu neun"
                onChange={handleInputChanged}
                maxCount="9"
            />
            <Box sx={{mt: 1,}}>
                <InputLabelStyled label="Bitte auswählen"/>
                <CheckboxStyled
                    label="privater Träger"
                    name="sponsor_private"
                    onChange={handleCheckboxChanged}
                    marginTop
                />
                <CheckboxStyled
                    label="staatlicher Träger"
                    name="sponsor_public"
                    onChange={handleCheckboxChanged}
                    marginTop
                />
            </Box>
        </>
    )
}

export default NetworkLocationFormMusikschulen;
